import axios from 'axios';
import { BookingServiceResponseDto, CreateBookingServiceDto, MessageResponseDto, UpdateBookingServiceDto } from '../types/booking';
import { SERVICES_API_BASE_URL } from './apiConfig';

const API_BASE = `${SERVICES_API_BASE_URL}/api/BookingService`;

const api = axios.create();

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const bookingCatalogApi = {
  getServices: () => api.get<BookingServiceResponseDto[]>(API_BASE),
  getActiveServices: () => api.get<BookingServiceResponseDto[]>(`${API_BASE}/active`),
  getService: (serviceId: string) => api.get<BookingServiceResponseDto>(`${API_BASE}/${serviceId}`),
  createService: (data: CreateBookingServiceDto) => api.post<BookingServiceResponseDto>(API_BASE, data),
  updateService: (serviceId: string, data: UpdateBookingServiceDto) => api.put<BookingServiceResponseDto>(`${API_BASE}/${serviceId}`, data),
  deleteService: (serviceId: string) => api.delete<MessageResponseDto>(`${API_BASE}/${serviceId}`),
};

